// src/App.jsx
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SeoHead from "./SeoHead";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

function ScrollToTop(){
  const { pathname } = useLocation();
  React.useEffect(()=>window.scrollTo({top:0,left:0,behavior:"auto"}),[pathname]);
  return null;
}

export default function App(){
  return (
    <>
      <SeoHead/>
      <Header/>
      <main id="main">
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/services" element={<Services/>}/>
          <Route path="/pricing" element={<Navigate to="/services" replace/>}/>
          <Route path="/gallery" element={<Gallery/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/404" element={<NotFound/>}/>
          <Route path="*" element={<Navigate to="/404" replace/>}/>
        </Routes>
      </main>
      <Footer/>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context":"https://schema.org",
          "@type":"LocalBusiness",
          "name":"A & M Audio",
          "address":{"@type":"PostalAddress","addressLocality":"Columbus","addressRegion":"OH","addressCountry":"US"},
          "image":"/hero.png",
          "url":"https://am-audio.netlify.app",
          "email":"austinlm132@gmail.com",
          "areaServed":"Columbus, OH",
          "priceRange":"$$"
        })
      }}/>
    </>
  );
}
